module.exports = __webpack_public_path__ + "static/media/PaddingNotselected.f3d2c793.svg";